import type { WiwState } from '@/store';

export const getParticipants = (state: WiwState) => {
  return state.workchat.participants;
};
